/* Supabase client — schema `kho`. Khóa anon là khóa công khai, RLS + RPC
   security definer mới là hàng rào thật (xem supabase/migrations/0001_kho.sql). */
import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY;
if (!url || !key) throw new Error('Thiếu VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY (xem .env.example)');

export const sb = createClient(url, key, {
  db: { schema: 'kho' },
  auth: { persistSession: true, autoRefreshToken: true }
});

/* Gọi RPC, ném Error có message tiếng Việt gọn khi lỗi */
export async function rpc(name, args) {
  const t0 = performance.now();
  const { data, error } = await sb.rpc(name, args || {});
  const ms = Math.round(performance.now() - t0);
  if (error) {
    const e = new Error(viMsg(error.message || String(error)));
    e.rpc = name; e.raw = error; e.ms = ms;
    throw e;
  }
  return { data, ms };
}

function viMsg(m) {
  if (/CHUA_DANG_NHAP/.test(m)) return 'Chưa đăng nhập';
  if (/MAY_CHUA_DANG_KY/.test(m)) return 'Tài khoản này chưa được gắn tên máy trong bảng kho.may — báo quản lý';
  if (/KHONG_CO_QUYEN/.test(m)) return 'Không có quyền (chỉ quản lý)';
  if (/schema must be one of|Could not find the function|PGRST106|PGRST202/.test(m))
    return 'Schema `kho` chưa được mở trong Supabase → Project Settings → Data API → Exposed schemas';
  if (/Failed to fetch|NetworkError|Load failed/.test(m)) return 'Mất kết nối mạng';
  return m;
}

export async function signIn(email, password) {
  const { data, error } = await sb.auth.signInWithPassword({ email, password });
  if (error) throw new Error(/Invalid login/i.test(error.message) ? 'Sai tài khoản hoặc mật khẩu' : viMsg(error.message));
  return data.session;
}
export async function signOut() { await sb.auth.signOut(); }
export async function getSession() { const { data } = await sb.auth.getSession(); return data.session; }

/* SHA-256 hex của một ArrayBuffer — chống nạp trùng file */
export async function sha256(buf) {
  const h = await crypto.subtle.digest('SHA-256', buf);
  return Array.from(new Uint8Array(h)).map((b) => b.toString(16).padStart(2, '0')).join('');
}
